<template>
  <div
    v-shortkey="{ close: ['esc'], submit: ['enter'] }"
    class="dev-widget"
    @shortkey="handleShortKey"
  >
    <div class="dev-widget-exit">
      Developer Widget
      <span
        class="dev-widget-exit__icon"
        @click="closeWidget"
        v-html="exitIcon"
      />
    </div>
    <div class="form-container">
      <label class="form-label dev-widget__label">System Service URL</label>
      <input
        v-model="endpoint"
        class="form-field"
      />
    </div>
    <div class="form-container">
      <label class="form-label dev-widget__label">Current Commit Hash</label>
      <input
        v-model="buildHash"
        disabled="true"
        class="form-field"
      />
    </div>
    <button
      class="btn mt-1"
      @click="setEndpoint"
    >
      Apply
    </button>
  </div>
</template>

<script>
import feather from 'feather-icons'
import {ENV} from '@/config'
import storageMixin from '../mixins/storageMixin';

export default {
  name: 'DevWidget',
  mixins: [ storageMixin ],
  data() {
    return {
      buildHash: ENV.buildNumber,
      endpoint: this.getStorage('endpoint_url') || ENV.ENDPOINT_URL,
      exitIcon: feather.icons.x.toSvg(),
    }
  },
  methods: {
    closeWidget() {
      this.$emit('close')
    },
    setEndpoint() {
      this.setStorage('endpoint_url', this.endpoint)
      location.reload()
    },
    handleShortKey(event) {
      const _action = event.srcKey
      const _actions = {
        submit: this.setEndpoint,
        close: this.closeWidget,
      }
      _actions[_action]()
    },
  },
}
</script>

<style lang="scss" scoped>
.dev-widget {
  position: fixed;
  right: 2rem;
  bottom: 2rem;
  width: 20%;
  height: auto;
  padding: 1rem;
  border-radius: 5px;
  box-shadow: 0 10px 20px $dark-grey;
  box-sizing: border-box;
  background: linear-gradient(to bottom right, $dark-grey, $black 80%);
  color: $white;
  &-exit {
    @include flex-display();
    @include flex-justify-content(space-between);
    width: 100%;
    margin-bottom: 1rem;
    font-weight: 600;
    &__icon {
      @include transition(transform 0.3s cubic-bezier(0.19, 1, 0.22, 1));
      @include transform(scale(0.8));
      &:hover {
        @include transform(scale(1));
        cursor: pointer;
      }
    }
  }
  &__label {
    color: $white;
  }
}
</style>
